import { render, staticRenderFns } from "./PageA4.vue?vue&type=template&id=5bcfdf2e&scoped=true"
import script from "./PageA4.vue?vue&type=script&lang=js"
export * from "./PageA4.vue?vue&type=script&lang=js"
import style0 from "./PageA4.vue?vue&type=style&index=0&id=5bcfdf2e&prod&lang=scss&scoped=true"
import style1 from "./PageA4.vue?vue&type=style&index=1&id=5bcfdf2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcfdf2e",
  null
  
)

export default component.exports